import { render, staticRenderFns } from "./TimeTabs.vue?vue&type=template&id=f5aa01ca&lang=html&"
import script from "./TimeTabs.vue?vue&type=script&lang=js&"
export * from "./TimeTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports